




































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import BankAccountDashboardResponseModel from '@/models/bankaccounts/BankAccountDashboardResponseModel';

@Component({
        name: 'BankAccountDashboard',
    },
)
export default class BankAccountDashboard extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;
    public showOverview: boolean = true;
    public showFunds: boolean = false;
    public showDetails: boolean = false;

    public get dashboard(): BankAccountDashboardResponseModel {
        return this.$store.state.selectedBankAccount;
    }

    public get lowAvailableTransactions(): boolean {
        if ( this.dashboard.availableTransactions < 10) {
            return true;
        }

        return false;
    }

    public get noAvailableFunds(): boolean {
        if ( this.dashboard.availableFunds === 0) {
            return true;
        }

        return false;
    }

    public get showDashboard(): boolean {
        if ( !this.initializing && !this.initializationError ) {
            return true;
        }

        return false;
    }

    public get opTypes(): any {
        return BankAccountOperations;
    }

    public showSection(id: number): void {
        this.showOverview = false;
        this.showFunds = false;
        this.showDetails = false;

        switch ( id )
        {
            case 1:
                this.showOverview = true;
                break;
            case 2:
                this.showFunds = true;
                break;
            case 3:
                this.showDetails = true;
                break;
        }
    }

    public showOperation(operationId: number): boolean {
        let show: boolean = false;

        if ( this.dashboard.authorizedOperations & operationId )
        {
            show = true;
        }

        return show;
    }

    public async created() {

        try {
            this.resetInitializationValues();

            const api = new BankAccountsApi();
            const response = await api.getBankAccountDashBoardAsync(this.bankAccountId, this.$store.state.member.jwt);
            this.$store.commit('mutateSelectedBankAccount', response);
        }
        catch ( err ) {
            await this.handleInitializationErrorAsync(err);
        }
        finally {
            this.initializing = false;
        }
    }
}

